<template>
  <div class="component-wrapper d-flex flex-column secondary">
    <div class="d-flex flex-column align-start px-2">
      <span
        @click="$router.push('/settings/about')"
        text
        class="white--text text-h6 flex-grow-0 mb-4"
        >{{ $t("info_settings.about_app") }}</span
      >
      <!-- <v-btn class="mt-2" @click="openAr"> open AR </v-btn> -->
      <v-bottom-sheet
        v-model="dialog"
        inset
        style="position: relative"
        scrollable
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            class="d-flex flex-column align-start mb-2"
          >
            <span text class="white--text text-h6 flex-grow-0">{{
              $t("info_settings.language")
            }}</span>
            <span v-if="language != null" class="body-2 grey--text">{{
              language.name
            }}</span>
          </div>
        </template>
        <v-card color="white" height="360px" class="px-6">
          <div class="text-h5 font-weight-bold pt-6">
            {{ $t("info_settings.choose-language") }}
          </div>
          <v-divider class="my-4"></v-divider>
          <div
            v-for="(lang, i) in languages"
            :key="i + lang.code"
            @click="componentLang = lang"
            class="mb-4"
          >
            <span
              :class="
                lang.code == componentLang.code
                  ? 'font-weight-bold'
                  : 'font-weight-regular'
              "
              class="body-1 d-flex align-center"
            >
              <span class="mr-auto">
                {{ lang.name }}
              </span>
              <v-icon color="brick" v-if="lang.code == componentLang.code">
                mdi-check
              </v-icon>
              <!-- <img
                v-if="lang.code == componentLang.code"
                class="check-icon"
                src="@/assets/icons/check.png"
              /> -->
            </span>
          </div>
        </v-card>
      </v-bottom-sheet>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      dialog: false,
    };
  },

  computed: {
    ...mapState({
      languages: (state) => state.base.languages,
      language: (state) => state.base.mobileLang,
    }),

    componentLang: {
      get() {
        return this.language;
      },
      set(newValue) {
        this.changeLang(newValue);
      },
    },

    menu() {
      return [
        {
          text: this.$t("info_settings.about"),
          path: "/settings/about",
        },

        {
          text: this.$t("info_settings.terms"),
          path: "/settings/terms_and_policies",
        },

        {
          text: this.$t("info_settings.contact"),
          path: "/settings/contact",
        },
      ];
    },
  },

  methods: {
    ...mapMutations(["setMobileLang"]),
    ...mapActions(["getCategories"]),

    async changeLang(lang) {
      this.setMobileLang(lang);
      this.$i18n.locale = this.language.code;
      await this.getCategories();
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>